


























































































import 'bootstrap';
import bootbox from 'bootbox';
import _ from 'underscore';
import binaryDownload from '@/services/BinaryDownloader';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { StudentProfile, IStudentProfile } from '@/classes/StudentProfile';
import Certificate from '@/classes/Certificate';
import { dateFormatter } from '@/services/inputTools';
import {sprintf} from 'sprintf-js';
import authorize, {Office} from '@/services/Authorize';


interface IUpdateCertDateResponse {
    certificate: Certificate;
    student: StudentProfile;
}

@Component({
    filters: {
        dateFormatter
    }
})
export default class StudentProfileView extends Vue {

    @Prop() public id!: string | number;

    get currentProfile(): StudentProfile {
        return this.$store.getters['students/getStudentById'](this.id);
    }

    get certificates(): Certificate[] {
        return null == this.currentProfile ? [] :
            this.$store.getters['certificates/getCertificatesByIds'](this.currentProfile.certificates);
    }

    get certificateFields() {
        return [{
            key: 'name',
            label: 'Course Name'
        }, {
            key: 'completionDate',
            label: 'Completion Date'
        }, {
            key: 'instructor',
            label: 'Instructor'
        }, {
            key: 'icons',
            label: ''
        }];
    }

    private currentEdits: number[] = [];

    private getCertificateName(certificate: Certificate): string {
        const certification = this.$store.getters['certifications/getCertificationById'](certificate.certificationId);
        return !certification ? '' : certification.name || '';
    }

    private getInstructorName(certificate: Certificate): string {
        const instructor = this.$store.getters['users/getUserProfileById'](certificate.instructorId);
        return !instructor ? '' : instructor.getFullName();
    }

    private saveCertificate(cert: Certificate) {

        this.$store.dispatch('certificates/saveCertificateDate', cert)
            .then((response: IUpdateCertDateResponse) => {
                this.editCertificate(cert, false);
                this.currentProfile.setActive(response.student.active, response.student.studentStatusDate);
            })
            .catch((err) => {
                bootbox.alert(err.message);
            });
    }

    private editCertificate(cert: Certificate, show: boolean) {

        if (show) {

            cert.editCertificationDate = cert.certificationDate;
            this.currentEdits.push(cert.id as number);

        } else {
            this.currentEdits = _.without(this.currentEdits, cert.id as number);
        }
    }

    private doRemoveCertificate(cert: Certificate) {
        this.$store.dispatch('certificates/removeCertificate', cert)
            .catch((err) => {
                bootbox.alert(err.message);
            });
    }

    private removeCertificate(cert: Certificate) {

        const msg = sprintf(`<p>Are you sure you want to remove</p>
            <p><strong>%s on %s</strong>?</p>
            <p><strong style="color:#F00">This cannot be undone!</strong></p>`,
            this.getCertificateName(cert),
            dateFormatter(cert.certificationDate)
        );

        bootbox.confirm(msg, (confirmed) => {
            if (confirmed) {
                this.doRemoveCertificate(cert);
            }
        });
    }

    private downloadStudentHistory(): void {
        binaryDownload('GET', sprintf('/api/v1/report/student_history/%d', this.currentProfile.id));
    }

    get canEdit(): boolean {
        if (authorize(Office)) {
            return true;
        } else {
            let canEdit = true;
            if (this.currentProfile !== undefined && this.currentProfile.jobCorpsCenterId !== undefined) {
                canEdit =  this.allowedCenters.includes(this.currentProfile.jobCorpsCenterId);
            }
            return canEdit;
        }
    }

    get allowedCenters(): number[] {
        return this.$store.getters.getActiveProfile ? this.$store.getters.getActiveProfile.jobCorpsCenterIds : [];
    }

    private reprintCertificate(cert: Certificate) {
        window.open('/print/v1/certificate/print/' + cert.id);
    }

    private canBePrinted(cert: Certificate) {
        if ( cert !== undefined && cert.canPrint) {
            return true;
        } else {
            return false;
        }
    }
}
